<div class="modal-conatiner">
  <h1 mat-dialog-title class="header-section" [ngStyle]="{'color': data.titleClr}">
    <img *ngIf="data.titleImg" src="../../assets/img/success-icon.svg" alt="next" class="success-icon" />
    <img *ngIf="data.titleImgPath" [src]="data.titleImgPath" class="success-icon"/>
    {{data.title}}
  </h1>
  <div  mat-dialog-content style="text-align: center;">
    {{data.message}}
  </div>
  <div class="mt-5">
    <button  mat-stroked-button color="primary" (click)="close(true)" class="ml-auto" [ngClass]="{'proceed-btn': data.proceedBtn}" >{{data.yes ? data.yes : yes}}</button>
    <button *ngIf="data.noCancelBtn" mat-stroked-button class="mx-2" color="warn" (click)="close(false)" [ngClass]="{'cancel-btn': data.cancelBtn}" >{{data.no ? data.no : no}}</button>
  </div>
</div>
